import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AdultLayout } from './AdultLayout';
import { AdultHomePage } from '../pages/adult/AdultHomePage';
import { ChildrenManagementPage } from '../pages/adult/ChildrenManagementPage';
import { ProgressTrackingPage } from '../pages/adult/ProgressTrackingPage';
import { AchievementsManagementPage } from '../pages/adult/AchievementsManagementPage';
import { ActivityManagementPage } from '../pages/adult/ActivityManagementPage';
import { SettingsPage } from '../pages/adult/SettingsPage';
import { BillingPage } from '../pages/adult/BillingPage';

export function AdultDashboard() {
  return (
    <Routes>
      <Route path="/" element={<AdultLayout />}>
        <Route index element={<AdultHomePage />} />
        <Route path="children" element={<ChildrenManagementPage />} />
        <Route path="progress" element={<ProgressTrackingPage />} />
        <Route path="achievements" element={<AchievementsManagementPage />} />
        <Route path="activities" element={<ActivityManagementPage />} />
        <Route path="billing" element={<BillingPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/adult" replace />} />
      </Route>
    </Routes>
  );
}